<template>
  <div class="common-layout">
    <el-container>
      <el-main style="padding: 0">
        <h3>月视图</h3>
        <el-calendar v-model="value" ref="calendar">
          <template #header="{ date }">
            <div class="header">
              <h2>{{ date.slice(0,6) }}</h2>
              <el-button type="primary" text @click="selectDate('prev-month')"><el-icon><ArrowLeftBold /></el-icon></el-button>
              <h2>{{ date.slice(6,12) }}</h2>
              <el-button type="primary" text @click="selectDate('next-month')"><el-icon><ArrowRightBold /></el-icon></el-button>
              <el-button type="primary" circle  @click="selectDate('today')">今</el-button>
            </div>
          </template>
          <template #date-cell="{ data }">
            <div class="dateDiv" :dataInfo="item=showWorkDate(data.day)" @click="selectWorkDate(data.day)">
              <div class="dateDivEdit">
                <text class="dayDiv">{{ data.day.split('-').slice(2).join('-') }}</text>
                <div class="div-text" style="margin-top: 2px">
                  <text class="workDiv" v-if="item.work_type==='work'">{{ "班" }}</text>
                  <text class="holidayDiv" v-if="item.work_type==='holiday'">{{ "节" }}</text>
                  <text class="restDiv" v-if="item.work_type==='weekend'">{{ "休" }}</text>
                </div>
              </div>
            </div>
          </template>
        </el-calendar>
      </el-main>
      <el-aside width="415px">
        <div style="height: 49%">
          <h3>当日详情</h3>
          <el-card style="max-width: 410px;height: 90%">
            <div>
              <div style="text-align: center">
                <h2>{{this.value.getFullYear()}}年{{this.value.getMonth()+1}}月{{this.value.getDate()}}日</h2>
                <h3>{{getWeek(this.value.getDay())}}</h3>
              </div>
              <div style="margin-top: 50px;">
                <el-form-item label="国家假日安排：">
                  <el-radio-group v-model="countryWorkType" style="margin-left: 10px">
                    <el-radio-button label="班" value="work" />
                    <el-radio-button label="休" value="weekend" />
                    <el-radio-button label="节" value="holiday" />
                  </el-radio-group>
                </el-form-item>
              </div>
              <div style="margin-top: 20px;text-align: center">
                <el-button type="primary" :loading="editLoading" @click="editWorkDate">保存</el-button>
              </div>
            </div>
          </el-card>
        </div>

        <div style="height: 49%">
          <h3>批量管理</h3>
          <el-card style="max-width: 410px;height: 90%">
            <el-form-item label="日期范围：">
              <el-date-picker
                  v-model="batchEditDate.date_range"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="YYYY-MM-DD"
              />
            </el-form-item>
            <el-form-item label="只修改周：">
              <el-checkbox-group v-model="batchEditDate.week">
                <el-checkbox value="1" name="week" size="small" style="margin-right: 8px">一</el-checkbox>
                <el-checkbox value="2" name="week" size="small" style="margin-right: 8px">二</el-checkbox>
                <el-checkbox value="3" name="week" size="small" style="margin-right: 8px">三</el-checkbox>
                <el-checkbox value="4" name="week" size="small" style="margin-right: 8px">四</el-checkbox>
                <el-checkbox value="5" name="week" size="small" style="margin-right: 8px">五</el-checkbox>
                <el-checkbox value="6" name="week" size="small" style="margin-right: 8px">六</el-checkbox>
                <el-checkbox value="7" name="week" size="small" style="margin-right: 8px">日</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-row>
              <el-col :span="23">
                <el-form-item label="国家假日安排：">
                  <el-radio-group v-model="batchEditDate.country_work_type" style="margin-left: 10px">
                    <el-radio-button label="班" value="work" />
                    <el-radio-button label="休" value="weekend" />
                    <el-radio-button label="节" value="holiday" />
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="text-align: center">
              <el-button type="primary" :loading="batchEditLoading" @click="batchEditWorkDate">保存</el-button>
            </div>
          </el-card>
        </div>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
import {ArrowLeftBold, ArrowRightBold} from "@element-plus/icons-vue";
import moment from "moment";

export default {
  name: "WorkDate",
  components: {ArrowLeftBold,ArrowRightBold},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        emitPath:false,
        value: 'type',
        label: 'name'
      },
      value :new Date(),
      dateLoading:[],
      dateMap:[],
      editLoading: false,
      batchEditLoading: false,
      currDayList: [],
      countryWorkDate:{},
      countryWorkType:'work',
      batchEditDate:{}
    }
  },
  methods: {
    selectDate(value) {
      this.$refs.calendar.selectDate(value);
      this.getWorkDateList(this.value);
      console.log(this.value);
    },
    showWorkDate(day) {
      if (this.dateMap[day] !== undefined) {
        return this.dateMap[day]
      }
      return ""
    },
    getWeek(day){
      let week = ['周日','周一', '周二', '周三', '周四', '周五', '周六'];
      return week[day];
    },
    async getWorkDateList(date) {
      let params = {date:date}
      this.dateMap = await this.$http('attendanceWorkDateService.getMonthWorkDateList', params);
      if(this.dateMap){
        const date =  moment(this.value).format('YYYY-MM-DD')
        this.selectWorkDate(date);
      }
    },
    async selectWorkDate(data){
      if (!this.dateMap[data]){
        let params = {date:data}
        this.dateMap = await this.$http('attendanceWorkDateService.getMonthWorkDateList', params);
        if(!this.dateMap){
          return;
        }
      }
      this.currDayList = this.dateMap[data];
      this.countryWorkDate = this.currDayList
      this.countryWorkType = this.currDayList.work_type
    },
    editWorkDate(){
      this.editLoading = true;
      let obj = {};
      let editData = [];
      editData.push(this.countryWorkDate);
      for (let i = 0; i < editData.length; i++) {
          console.log(obj[i])
          editData[i].work_type = this.countryWorkType
      }
      obj.list = editData;
      this.$http('attendanceWorkDateService.editWorkDate', obj, false).then(() => {
        this.$message.success("保存成功");
        this.getWorkDateList(this.value);
        this.editLoading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.editLoading = false;
      })
    },
    batchEditWorkDate(){
      console.log(this.batchEditDate);
      if(!this.batchEditDate.date_range){
        return this.$message.error("请选择日期范围");
      }
      if(!this.batchEditDate.country_work_type){
        return this.$message.error("请选择国家假日安排");
      }
      this.$http('attendanceWorkDateService.batchEditWorkDate', this.batchEditDate, false).then(() => {
        this.$message.success("保存成功");
        this.getWorkDateList(this.value);
        this.batchEditLoading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.batchEditLoading = false;
      })
    }
  },
  created() {
    this.getWorkDateList(this.value);
  }
}
</script>

<style scoped>

.header {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.dateDiv {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.dateDivEdit {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 17px;
}

.div-text {
  width: 25px;
  height: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 17px;
}

.restDiv {
  width: 25px;
  height: 25px;
  text-align: center;
  border-radius: 50%;
  color: whitesmoke;
  background-color: rgb(250, 124, 77);
}

.workDiv {
  width: 25px;
  height: 25px;
  text-align: center;
  border-radius: 50%;
  color: black;
  background-color: #e5e5e5;
}

.holidayDiv {
  width: 25px;
  height: 25px;
  text-align: center;
  border-radius: 50%;
  color: whitesmoke;
  background-color: #42b983;
}

</style>